// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dgae","left":"styles_left__31OBY"};